import { render, staticRenderFns } from "./taskDispatchDetail.vue?vue&type=template&id=aef7fd44&scoped=true"
import script from "./taskDispatchDetail.vue?vue&type=script&lang=js"
export * from "./taskDispatchDetail.vue?vue&type=script&lang=js"
import style0 from "./taskDispatchDetail.vue?vue&type=style&index=0&id=aef7fd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef7fd44",
  null
  
)

export default component.exports